import { COMPANY } from "@/lib/siteContent";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="pt-36 sm:pt-44 pb-24 sm:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl">
          <p
            data-testid="hero-eyebrow"
            className="text-xs sm:text-sm uppercase tracking-[0.25em] text-[#6B7280] mb-8 fade-up"
          >
            Premium Freight Dispatching
          </p>
          <h1
            data-testid="hero-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#0F2A44] fade-up"
            style={{ animationDelay: "80ms" }}
          >
            We find the loads.
            <br />
            <span className="italic text-[#0F2A44]">You drive the miles.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-8 text-base sm:text-lg leading-relaxed text-[#1A1A1A]/80 max-w-2xl fade-up"
            style={{ animationDelay: "180ms" }}
          >
            Crownpath is a boutique freight dispatching service for owner-operators
            and small fleets. We hunt loads, negotiate rates, and handle the paperwork —
            so you can keep your truck moving and your margins healthy. Flat {COMPANY.rate}. No long-term contracts.
          </p>

          <div
            className="mt-12 flex flex-col sm:flex-row gap-5 sm:items-center fade-up"
            style={{ animationDelay: "280ms" }}
          >
            <a
              href="#contact"
              onClick={scrollTo("#contact")}
              data-testid="hero-cta-primary"
              className="inline-flex items-center justify-center bg-[#0F2A44] text-white px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-[#0F2A44]/90 transition-colors"
            >
              Get Started
            </a>
            <a
              href={COMPANY.phoneHref}
              data-testid="hero-cta-secondary"
              className="inline-flex items-center text-sm tracking-wide text-[#0F2A44] border-b-2 border-[#D4AF7F] pb-1 w-fit hover:text-[#D4AF7F] transition-colors"
            >
              Call {COMPANY.phone}
            </a>
          </div>

          <div
            className="mt-20 grid grid-cols-2 sm:grid-cols-3 gap-y-8 gap-x-12 max-w-2xl fade-up"
            style={{ animationDelay: "400ms" }}
          >
            {[
              { k: "5%", v: "Flat dispatch rate" },
              { k: "24h", v: "Onboarding turnaround" },
              { k: "48", v: "States covered" },
            ].map((stat) => (
              <div key={stat.v} data-testid="hero-stat">
                <div className="font-serif text-3xl sm:text-4xl text-[#0F2A44]">
                  {stat.k}
                </div>
                <div className="mt-2 text-xs uppercase tracking-[0.2em] text-[#6B7280]">
                  {stat.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
